// extracted by mini-css-extract-plugin
export default {"modalWrapper":"FullScreenImage_modalWrapper__d8Taz","next":"FullScreenImage_next__tIEr1","prev":"FullScreenImage_prev__K8ZGZ","close":"FullScreenImage_close__88GcA"};